export default __webpack_public_path__ + "static/media/payments.c2a99a45.svg";